export default __webpack_public_path__ + "locales/lo-LA/ChangePortalOwner.json?hash=214eb4906331dcc7df82175ef197484a";